import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg width={26} height={22} viewBox="0 0 26 22" fill="none" {...props}>
      <Path
        d="M18 6H2C.89 6 .01 6.89.01 8L0 20c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 14H3c-.55 0-1-.45-1-1v-5h16v5c0 .55-.45 1-1 1zm1-10H2V8h16v2z"
        fill="#E40046"
      />
      <Path
        d="M24 8.714h1V5.286h-4.286V1h-3.428v4.286H13v3.428h4.286V13h3.428V8.714H24z"
        fill="#FFB800"
        stroke="#fff"
        strokeWidth={2}
      />
    </Svg>
  );
}

export default SvgComponent;
